import QTable from 'quasar/src/components/table/QTable.js';

export const adminContentIStatisticsTableColumns = (): QTable['columns'] => [
  {
    name: 'id',
    field: 'id',
    label: 'نام و نام‌خانوادگی',
    align: 'center'
  },
  {
    name: 'role',
    field: 'role',
    label: 'نقش',
    align: 'center'
  },
  {
    name: 'content_items_count',
    field: 'content_items_count',
    label: 'تعداد مقالات',
    align: 'center',
    format: val => (val !== null ? val : 'ندارد')
  },
  {
    name: 'content_items_sum_word_count',
    field: 'content_items_sum_word_count',
    label: 'تعداد کلمات',
    align: 'center'
  },
  {
    name: 'content_items_sum_writer_share',
    field: 'content_items_sum_writer_share',
    label: 'سهم نویسنده',
    align: 'center'
  },
  {
    name: 'content_items_sum_editor_share',
    field: 'content_items_sum_editor_share',
    label: 'سهم ویراستار',
    align: 'center'
  },
  {
    name: 'writer_wallet',
    field: 'writer_wallet',
    label: 'کیف پول نویسنده',
    align: 'center'
  }
]
